export default class ObjectService {
    getPropValue = (obj:any, field?:string) => {
        var fieldname = this.getPropName(obj, field);
        if (!fieldname) return undefined;

        return obj[fieldname];
    }
    getPropName = (obj:any, field?:string) => {
        if (!obj) return undefined;
        if (!field) return undefined;
        return Object.getOwnPropertyNames(obj).find(o => o.trim().toLowerCase() === field.trim().toLowerCase());
    }

    uuidv4 = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-mixed-operators
        var r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
    
    /**
     * Devuelve el valor de una propiedad de un objeto haciendo cascada de propiedades
     * @param obj objeto
     * @param propNames propiedades 
     * @returns 
     * undefined: problemas con los parámetros 
     * null: ruta no se pudo completar
     * any: valor
     */
    getCascadePropValue = (obj: any, propNames: string) => {
        if (obj === null || obj === undefined) return undefined;
        if (typeof propNames !== 'string' || propNames === null || propNames === undefined || propNames.length < 1) return undefined;
        if (typeof obj !== 'object') return undefined;

        //console.log("buscando field - objeto", obj)
        let pointer = obj;
        const names = propNames.split('.');
        names.forEach((name, index) => {
            
            //console.log("buscando field", name)

            if (typeof pointer !== 'object' || pointer === undefined || pointer === null) return null;
            let aux = null;
            if (name.startsWith("[") && name.endsWith("]")) {
                // eslint-disable-next-line no-eval
                aux = eval(`pointer.find(p => ${name.substring(1, name.length - 1).replace(/\*/gi, 'p.' )})`);
                //console.log("buscando field (find)", `pointer.find(p => ${name.substring(1, name.length - 1).replace(/\*/gi, 'p.' )})`, " = ",aux)
            } else {
                aux = pointer[name];
            }
            pointer = aux;
        })
        return pointer;
    }

    setCascadePropValue = (obj: any, propNames: string, value: any, onUndefined?: (field:string) => any) => {
        if (obj === null || obj === undefined) return undefined;
        if (typeof propNames !== 'string' || propNames === null || propNames === undefined || propNames.length < 1) return undefined;
        if (typeof obj !== 'object') return undefined;

        let pointer = obj;
        const names = propNames.split('.');
        names.forEach((name, index) => {
            if (index === names.length - 1) return; // ultimo
            if (typeof pointer !== 'object' || pointer === undefined || pointer === null) return null;  // creo que esto ya no sirve
            let aux = null;
            if (name.startsWith("[") && name.endsWith("]")) {
                // eslint-disable-next-line no-eval
                aux = eval(`pointer.find((p,i) => ${name.substring(1, name.length - 1).replace(/\*/gi, 'p.' )})`);
                //console.log("FIND EVAL", `pointer.find((p,i) => ${name.substring(1, name.length - 1).replace(/\*/gi, 'p.' )})`, "pointer", pointer, "result", aux)
            } else {
                aux = pointer[name];
            }
            if (!aux && onUndefined) {
                aux = onUndefined(name);
                if (name.startsWith("[") && name.endsWith("]")) {
                    pointer.push(aux);
                } else {
                    pointer[name] = aux;
                }
            }
            pointer = aux;
        })
        pointer[names[names.length - 1]] = value;
    }
}